export default {
	data: function () {
		return {
			options: [
				{name: 'Hello', value: 'hello'},
				{name: 'World', value: 'world'}
			],
			selected: {name: 'Hello', value: 'hello'},
			system: {},
			popoverOpen: false
		};
	},
	methods: {
		togglePopover: function () {
			this.popoverOpen = !this.popoverOpen;
		}
	}
}